export const calculatePercentage = (amount, percentage) => {
    let percentageAmount = (amount * percentage) / 100;
    return Math.floor(percentageAmount);
}

export const formattedAmount = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};